module.exports = __webpack_public_path__ + "static/Lato-Bold-44dfe8cc676882243911a3197a50169e.ttf";